<script>
  import FilterIcon from "../../../Common/Icons/FilterIcon.svelte";

  export let openFiltersModal = () => {};
</script>

<button on:click|preventDefault={() => openFiltersModal()}>
  <FilterIcon />
  <span>Filter</span>
</button>

<style>
  button {
    color: white;
    background: #006b97;
    padding: 15px;
    border: none;
    border-radius: 15px;
    display: flex;
  }

  span {
    margin-left: 10px;
    font-family: "Segoe UI", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
  }
</style>
